/**
 * Talent Bank constants (Arabic).
 */
export const ENTITY_TYPES = [
  'روضة أطفال',
  'مرحلة ما قبل المدرسة',
  'مركز رعاية نهارية',
  'مدرسة دولية',
  'مدرسة أهلية',
  'مدرسة حكومية',
  'مركز تدريب تربوي',
  'شركة استشارات تعليمية',
  'منظمة غير ربحية',
  'أخرى',
];

export const PROFILE_STATUSES = ['New', 'Reviewed', 'Suitable', 'Not Suitable', 'Archived'];
export const REQUEST_STATUSES = ['New', 'Under Review', 'Contacted', 'Closed', 'Archived'];

export const STATUS_LABEL_AR = {
  New: 'جديد',
  Reviewed: 'تمت المراجعة',
  Suitable: 'مناسب',
  'Not Suitable': 'غير مناسب',
  Archived: 'مؤرشف',
  'Under Review': 'قيد المراجعة',
  Contacted: 'تم التواصل',
  Closed: 'مغلق',
};

export const MAX_CV_MB = 5;
export const MAX_CV_BYTES = MAX_CV_MB * 1024 * 1024;
